import { PxdColumns } from '@app/shared/kendoui/grid/interfaces/pxd-columns';

export const columns: PxdColumns[] = [
  {
    field: 'AfeNumber',
    title: 'WBS Number',
    params: {
      lock: false,
      width: 170,
      type: 'string',
      display: true,
      skip: true,
      filterable: true,
      hide: false
    }
  },
  {
    field: 'WBSType',
    title: 'WBS Type',
    params: {
      lock: false,
      width: 250,
      type: 'string',
      display: true,
      skip: true,
      filterable: true,
      hide: false,
    }
  },
  {
    field: 'WBSSubType',
    title: 'WBS Sub Type',
    params: {
      lock: false,
      width: 220,
      type: 'string',
      display: true,
      skip: true,
      filterable: true,
      hide: false,
    }
  },
  {
    field: 'AfeApprovalTeam',
    title: 'WBS Approval Team',
    params: {
      lock: false,
      width: 200,
      type: 'string',
      display: true,
      skip: false,
      filterable: true,
      hide: false
    }
  },
  {
    field: 'WBSRecordStatus',
    title: 'WBS Status',
    params: {
      lock: false,
      width: 120,
      type: 'string',
      display: true,
      skip: false,
      filterable: true,
      hide: false
    }
  },
  {
    field: 'ProjectStatus',
    title: 'Project Status',
    params: {
      lock: false,
      width: 120,
      type: 'string',
      display: true,
      skip: false,
      filterable: true,
      hide: false,
      data: 'projectStatuses',
      customFilter: 'multiselect'
    }
  },
  {
    field: 'ProjectId',
    title: 'Project ID',
    params: {
      lock: false,
      width: 140,
      type: 'number',
      display: true,
      skip: true,
      filterable: true,
      hide: false
    }
  },

  {
    field: 'Name',
    title: 'Project Name',
    params: {
      lock: false,
      width: 450,
      type: 'string',
      display: true,
      skip: true,
      filterable: true,
      hide: false
    }
  },
  {
    field: 'ProjectType',
    title: 'Project Type',
    params: {
      lock: false,
      width: 250,
      type: 'string',
      display: true,
      skip: false,
      filterable: true,
      hide: false,
      data: 'projectTypes',
      customFilter: 'multiselect'
    }
  },
  {
    field: 'ProjectSubType',
    title: 'Project Subtype',
    params: {
      lock: false,
      width: 200,
      type: 'string',
      display: true,
      skip: false,
      filterable: true,
      hide: false,
      data: 'projectSubTypes',
      customFilter: 'multiselect'
    }
  },

  {
    field: 'CostCenter',
    title: 'Cost Center',
    params: {
      lock: false,
      width: 140,
      type: 'string',
      display: true,
      skip: false,
      filterable: true,
      hide: true
    }
  },
  {
    field: 'AssetTeamCode',
    title: 'Asset Team',
    params: {
      lock: false,
      width: 120,
      type: 'string',
      display: true,
      skip: false,
      filterable: false,
      hide: true
    }
  },
  {
    field: 'StartDate',
    title: 'Project Start',
    params: {
      lock: false,
      width: 140,
      type: 'date',
      display: true,
      skip: true,
      filterable: true,
      hide: true
    }
  },
  {
    field: 'ProjectTechId',
    displayField: 'ProjectTechName',
    title: 'Project Tech',
    params: {
      lock: false,
      width: 230,
      type: 'string',
      display: true,
      skip: false,
      filterable: true,
      hide: false,
      data: 'employeeList',
      customFilter: 'employee'
    }
  },
  {
    field: 'ProjectControlsAnalystId',
    displayField: 'ProjectControlsAnalystName',
    title: 'Project Controls Analyst',
    params: {
      lock: false,
      width: 230,
      type: 'string',
      display: true,
      skip: false,
      filterable: true,
      hide: true,
      data: 'employeeList',
      customFilter: 'employee'
    }
  },
  {
    field: 'ProjectEngineerId',
    displayField: 'ProjectEngineerName',
    title: 'Project Engineer',
    params: {
      lock: false,
      width: 230,
      type: 'string',
      display: true,
      skip: false,
      filterable: true,
      hide: true,
      data: 'employeeList',
      customFilter: 'employee'
    }
  },
  {
    field: 'ProjectManagerId',
    displayField: 'ProjectManagerName',
    title: 'Project Manager',
    params: {
      lock: false,
      width: 230,
      type: 'string',
      display: true,
      skip: false,
      filterable: true,
      hide: true,
      data: 'employeeList',
      customFilter: 'employee'
    }
  },
  {
    field: 'ProgramManagerId',
    displayField: 'ProgramManagerName',
    title: 'Program Manager',
    params: {
      lock: false,
      width: 230,
      type: 'string',
      display: true,
      skip: false,
      filterable: true,
      hide: false,
      data: 'employeeList',
      customFilter: 'employee'
    }
  },
  {
    field: 'CreatedBy',
    title: 'Created By',
    params: {
      lock: false,
      width: 230,
      type: 'string',
      display: true,
      skip: true,
      filterable: true,
      hide: true,
      filter: 'text'
    }
  },
  {
    field: 'BudgetCategoryName',
    //displayField: 'BudgetCategoryName',
    title: 'Budget Category',
    params: {
      lock: false,
      width: 230,
      type: 'string',
      display: true,
      skip: false,
      filterable: true,
      hide: true,
      //data: 'employeeList',
      //customFilter: 'employee'
    }
  },
  {
    field: 'AfeApprovalDate',
    title: 'Approval Date',
    params: {
      lock: false,
      width: 140,
      type: 'date',
      display: true,
      skip: true,
      filterable: true,
      hide: true
    }
  },
  {
    field: 'CapitalOperationalExpendature',
    title: 'CapEx/OpEx',
    params: {
      lock: false,
      width: 140,
      type: 'string',
      display: true,
      skip: false,
      filterable: true,
      hide: true
    }
  }
];

